import React from "react";
import Chart from "./Chart";

function ExpensesChart(props) {
  const datapoints = [
    { label: "Jan", value: 0 },
    { label: "Feb", value: 0 },
    { label: "Mar", value: 0 },
    { label: "Apr", value: 0 },
    { label: "May", value: 0 },
    { label: "Jun", value: 0 },
    { label: "Jul", value: 0 },
    { label: "Aug", value: 0 },
    { label: "Sep", value: 0 },
    { label: "Oct", value: 0 },
    { label: "Nov", value: 0 },
    { label: "Dec", value: 0 },
  ];
  let expense = "";
  for (expense of props.expenses) {
    const month = expense.date.getMonth();
    datapoints[month].value += expense.amount;
  }
  return (
    <div>
      <Chart dataPoints={datapoints} />
    </div>
  );
}

export default ExpensesChart;
